<div class="logout-wrapper" [ngClass]="position" (click)="onLogout()">
  <span class="logout-text">Wyloguj się </span>
  <span class="lnr lnr-power-switch"></span>
</div>
